// extracted by mini-css-extract-plugin
module.exports = {"button":"exit-button_button__2XLeC","icon":"exit-button_icon__2eA0o"};